module.exports = __webpack_public_path__ + "img/intprep.a59193e0.avif";